import { FieldPolicy } from '@apollo/client'

export const unmatchedConversationsV2: FieldPolicy = {
  keyArgs: ['queueNames'],
}
